import defaultProperties from './default'
import Component from './Component'
import PropertyEditor from "./PropertyEditor";

export default {
    Component,
    PropertyEditor,
    defaultProperties
}
